<template>
    <v-card style="max-width: 432px; margin: auto">
        <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
            <v-text type="headline">
                Смена пароля
            </v-text>
        </div>

        <div v-padding.left="8" v-padding.right="8" v-padding.bottom="3">
            <v-form @submit="handleSubmit" :validate="validate" :readonly="isChanging">
                <template scope="api">
                    <v-form-input v-margin.bottom="2" field="oldPassword" type="password" label="Текущий пароль" />
                    <v-form-input v-margin.bottom="2" field="newPassword" type="password" label="Новый пароль" />
                    <v-form-input v-margin.bottom="4" field="confirmPassword" type="password" label="Подтвердить пароль" />
                    <v-spinner :active="isChanging" style="width: 100%">
                        <v-button block type="submit" primary :disabled="api.isInvalid || isChanging">
                            изменить пароль
                        </v-button>
                    </v-spinner>
                    <div v-text-align.center v-margin.top="2">
                        <v-text v-if="error" danger>
                            {{ error }}
                        </v-text>
                    </div>
                    
                </template>
            </v-form>
        </div>
    </v-card>
</template>
<script>
    import { validate, isRequired } from '../../../services/validator';

    export default {
        name: 'profile-password',
        props: {
            onChange: Function,
        },
        data() {
            return {
                isChanging: false,
                error: ''
            }
        },
        methods: {
            validate(values) {
                const rules = {
                    confirmPassword: [
                        isRequired,
                        (pass) => pass === values.newPassword
                            ? undefined
                            : 'Пароли не совпадают',
                    ],
                    newPassword: [
                        isRequired,
                        (pass) => pass.length > 5
                            ? undefined
                            : 'Пароль не должен быть меньше 6 символов',
                        (pass) => pass.length <= 20
                            ? undefined
                            : 'Пароль не должен быть больше 20 символов',
                    ],
                    oldPassword: [
                        isRequired
                    ],
                };

                return validate(values, rules);
            },
            handleSubmit(values) {
                if (this.isChanging) {
                    return;
                }

                this.isChanging = true;

                this.onChange(values)
                    .then((res) => {
                        this.isChanging = false;
                        this.$router.go(-1);
                    })
                    .catch((res) => {
                        this.isChanging = false;
                        this.error = res.data.message;
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ProfilePassword.vue?07646e18